import type { ISystemParam } from '../interfaces/system-params';
import type { SmtpConfiguration } from './notification-configuration-api.service';
import { booleanSystemParam } from './boolean-system-param';

export type SmtpConfigurationResult =
  | { available: true; value: SmtpConfiguration }
  | { available: false; value: null };

export function smtpConfigurationParams(
  result: SmtpConfigurationResult,
): ISystemParam[] {
  const description = result.available
    ? 'Настройка окружения сервиса уведомлений'
    : 'Сервис уведомлений недоступен';
  const smtp = result.value;
  const value = (current: unknown) =>
    result.available
      ? current == null || current === ''
        ? '—'
        : current
      : 'Недоступно';
  const securityLabels: Record<string, string> = {
    StartTls: 'STARTTLS',
    SslOnConnect: 'TLS при подключении',
    None: 'Без TLS',
  };
  const security =
    smtp?.security == null
      ? null
      : (securityLabels[smtp.security] ?? smtp.security);
  const row = (id: string, name: string, current: unknown): ISystemParam => ({
    id,
    name,
    value: String(value(current)),
    description,
    minValue: null,
    maxValue: null,
    inputMask: '.',
    regexpMask: '',
    isProtected: true,
  });
  return [
    booleanSystemParam(
      {
        id: 'smtp:configured',
        name: 'SMTP настроен',
        description,
        isProtected: true,
      },
      smtp?.configured,
    ),
    row('smtp:host', 'Сервер SMTP', smtp?.host),
    row('smtp:port', 'Порт SMTP', smtp?.port),
    row('smtp:security', 'Защита соединения SMTP', security),
    row('smtp:fromAddress', 'Адрес отправителя', smtp?.fromAddress),
    row('smtp:fromName', 'Имя отправителя', smtp?.fromName),
    booleanSystemParam(
      {
        id: 'smtp:authenticationConfigured',
        name: 'Аутентификация SMTP настроена',
        description,
        isProtected: true,
      },
      smtp?.authenticationConfigured,
    ),
  ];
}
